import { Controller, useWatch, type Control, type FieldErrors } from "react-hook-form";
import { Panel } from "primereact/panel";
import { RelativeDatePicker } from "@/components/forms";
import type { BookableEventFormData } from "@/lib/event-schemas";

export function BookingInfoFields(props: {
  control: Control<BookableEventFormData>;
  errors: FieldErrors<BookableEventFormData>;
  referenceDate?: Date | null;
  referenceDateLabel?: string;
}) {
  const sessions = useWatch({ control: props.control, name: "sessions" });

  const computedReferenceDate =
    props.referenceDate ||
    (sessions && sessions.length > 0
      ? sessions.reduce<Date | null>((earliest: Date | null, session: BookableEventFormData["sessions"][number]) => {
          const startsAt = session?.startsAt;
          if (!(startsAt instanceof Date)) return earliest;
          if (!earliest || startsAt < earliest) return startsAt;
          return earliest;
        }, null)
      : null);

  return (
    <Panel header="Booking Information">
      <div className="flex flex-column gap-2">
        <Controller
          control={props.control}
          name="bookingClosesAt"
          render={({ field }) => (
            <RelativeDatePicker
              id="bookingClosesAt"
              label="Booking Closes At"
              optional
              error={props.errors.bookingClosesAt?.message}
              helperText="When bookings for this event should close (relative to event start)"
              value={field.value ?? null}
              onChange={(date) => field.onChange(date)}
              referenceDate={computedReferenceDate}
              referenceDateLabel="event start"
              allowAfterOptions={true}
            />
          )}
        />
      </div>
    </Panel>
  );
}


